import { HTMLAttributes } from 'react'

import { useCurrentUrl } from 'hooks/useCurrentUrl'

import { StyledArrowButton } from './index.styled'

export type ArrowButtonProps = {
  position: 'left' | 'right'
} & HTMLAttributes<HTMLDivElement>
export const ArrowButton = ({
  position = 'left',
  className,
  ...rest
}: ArrowButtonProps) => {
  const currentUrl = useCurrentUrl()
  return (
    <StyledArrowButton
      position={position}
      role="button"
      {...rest}
      className={`${className} pointer-event-child-none`}
      data-event-category="Health Tool"
      data-event-action="Due Date Arrow Click"
      data-event-label={currentUrl}
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          d="M9.14323 9.99983L12.2 6.94303C12.5312 6.61183 12.5312 6.07423 12.2 5.74303C11.8688 5.41183 11.3312 5.41183 11 5.74303L7.30883 9.43423C6.99603 9.74703 6.99603 10.2534 7.30883 10.5654L11 14.2566C11.3312 14.5878 11.8688 14.5878 12.2 14.2566C12.5312 13.9254 12.5312 13.3878 12.2 13.0566L9.14323 9.99983Z"
          fill="#595959"
        />
      </svg>
    </StyledArrowButton>
  )
}
